module.exports = __webpack_public_path__ + "img/subtract.15794c1b.svg";